import React, { createContext, useContext } from 'react';
import { PermissionType, UserContext } from './UserProvider';

const PermissionsContext = createContext<PermissionType[]>([]);

//DA ELIMINARE quando sarà passato l'array permissions dal be
/* const testPermissions = [
    {
        name: 'view-projects-list',
        labelIt: 'Visualizza Lista Progetti',
        labelEn: 'View Projects List',
        descriptionIt: 'Visualizza esclusivamente la lista dei progetti',
        descriptionEn: 'View only the list of projects',
        category: 'landing',
    }
]; */

export const PermissionsProvider = ({ children }: { children: React.ReactNode }) => {
    const { myUser } = useContext(UserContext);

    if (!myUser) return children;

    //myUser.permissions = testPermissions; //DA ELIMINARE quando sarà passato l'array permissions dal be

    const permissions: PermissionType[] = Array.isArray(myUser.permissions) ? myUser.permissions : [];

    return (
        <PermissionsContext.Provider value={permissions}>
            {children}
        </PermissionsContext.Provider>
    );
};

export const usePermissions = () => useContext(PermissionsContext);

/* 
    ESEMPIO DI UTILIZZO: Pulsanti, sezioni, elementi UI

    <WithPermission permission="create-project"> <-- se un permesso
        <button>Nuovo Progetto</button>
    </WithPermission>

    <WithPermission permission={["edit-project", "delete-project"]}> <-- se almeno un permesso
        <button>Azioni Avanzate</button>
    </WithPermission>

    <WithPermission permission={["publish", "approve"]} mode="all"> <-- se tutti i permessi
        <button>Pubblica Progetto</button>
    </WithPermission>

    --------------------------------------------------------

    ESEMPIO DI UTILIZZO: Intere pagine

    const SettingsPage = () => {
        const hasPermission = useHasPermission(["view-settings", "edit-settings"], "all");  <--- array delle key + modalità "all" o "any"

        if (!hasPermission) return <Unauthorized />;

        return <ProjectsList />;
    };
*/